// Deterministic sourceKey derivation for connector intervals.
// The ingestion funnel dedupes on (ownerID, source, sourceKey) — the provider
// row is owner- and source-scoped, so keys only need to be stable and unique
// within one provider's data. Shared so both tiers derive identical keys.

// Collapse whitespace + lowercase so cosmetic edits at the source ("Acme  Inc"
// vs "acme inc") don't mint a new key and duplicate the event on re-import.
const normalizeKeyPart = (value) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

// LinkedIn Positions.csv rows have no stable id; company + title + start month
// is the identity of a position. startedOnISO is an ISO 8601 string — only the
// year-month is used, matching the export's month granularity.
export const deriveSourceKeyLinkedIn = ({ companyName, title, startedOnISO }) =>
  [
    normalizeKeyPart(companyName),
    normalizeKeyPart(title),
    String(startedOnISO ?? "").slice(0, 7),
  ].join("|");
